import React from 'react';
import { animated } from 'react-spring';
import styled from 'styled-components';
import SVGLoader from '@rsos/assets/icons/src/SVGLoader';
import { Box, Text } from '@rsos/components/capstone/base';

export const TextContainer = styled(animated(Box)).attrs({
  justify: 'center',
  align: 'center',
  bg: 'transparent',
  marginTop: '5px',
})`
  overflow: hidden;
`;
export const TextWrapper = styled(Text).attrs({
  color: 'primaryText',
  size: 'normal',
})`
  font-family: Soleil;
`;

export const PremiumText = props => (
  <SVGLoader
    width={73}
    height={19}
    viewboxHeight={19}
    viewboxWidth={73}
    fill={props.color}
  >
    <path d="M11.0141 7.55999C11.0141 11.52 9.50205 13.716 5.90205 13.716C2.37405 13.716 0.862061 11.52 0.862061 7.55999V0.899994H3.43607V7.90199C3.43607 10.314 4.40806 11.466 5.93806 11.466C7.46806 11.466 8.44006 10.314 8.44006 7.90199V0.899994H11.0141V7.55999ZM16.3571 5.61599V13.5H13.7831V0.899994H16.0511L21.8831 8.80199V0.899994H24.4571V13.5H22.1351L16.3571 5.61599ZM27.2481 0.899994H29.8221V13.5H27.2481V0.899994ZM36.9291 13.5H34.3551V3.07799H31.3671V0.899994H39.9171V3.07799H36.9291V13.5ZM41.4681 0.899994H49.5501V3.07799H44.0421V5.922H49.5501V8.09999H44.0421V11.322H49.5501V13.5H41.4681V0.899994Z" />
  </SVGLoader>
);
